import 'jquery';
import '@seo/js/common';
import { initGoogleTagManager } from './common/google_tag_manager';

initGoogleTagManager();

const lazyLoad = async () => {
  await import('@zr/common/js/ketch');
  await import('@zr/common/js/load-video-prompt');
  await import('@zr/common/js/jquery-plugins/jquery.modal');
};

lazyLoad();
